import React, { Component } from 'react';
import { withTranslation, TFunction } from 'react-i18next';
import { ArrowLeft } from '../../../assets/icons';
import UploadFileComponent from '../../../components/UploadFileComponent/UploadFileComponent';
import './FileUploadedPage.css';

// Match reference: Simple props interface
interface FileUploadedPageProps {
  t?: TFunction;
  navigate?: (path: string, params?: any) => void;
  goBack?: () => void;
  
  // Navigation parameters (from URL query strings)
  leave_id?: string | null;
  children_id?: string | null;
  is_submit_missing_note?: boolean | null;
}

interface FileUploadedPageState {
  // Match reference: Empty state
}

class FileUploadedPage extends Component<FileUploadedPageProps, FileUploadedPageState> {
  constructor(props: FileUploadedPageProps) {
    super(props);
    // Match reference: Empty state
    this.state = {};
  }

  render() {
    const { t } = this.props;

    return (
      <div className="file-uploaded-page">
        {/* Match reference: Simple header structure */}
        <div className="page-header">
          <div className="page-header-inner">
            <div className="header-left">
              <button
                className="header-button back-button"
                onClick={() => this.props.goBack?.()}
              >
                <ArrowLeft />
              </button>
              <h1 className="header-title">
                {t?.("select-leavere-quest:upload-file")}
              </h1>
            </div>
            
            <div className="header-right">
              {/* Empty for now */}
            </div>
          </div>
        </div>

        {/* Match reference: Direct UploadFileComponent usage */}
        <div className="page-content">
          <UploadFileComponent
            leave_id={this.props.leave_id}
            children_id={this.props.children_id}
            missing={true}
            is_submit_missing_note={this.props.is_submit_missing_note}
            isSickImage={true}
            navigate={this.props.navigate}
          />
        </div>
      </div>
    );
  }
}

// Match reference: No Redux connection (empty maps)
const mapStateToProps = (state: any) => {
  return {};
};

const mapDispatchToProps = (dispatch: any) => {
  return {};
};

// Match reference: Export with translation only
export default withTranslation()(FileUploadedPage);